import { CartUpdateEvent } from '@theme/events';

/** Clear uses Shopify's cart response and bundled sections; prices and counts are never guessed. */
class RsCartClear extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.querySelector('button')?.addEventListener('click', () => this.clear(), { signal: this.controller.signal });
  }
  async clear() {
    if (this.busy || document.documentElement.dataset.rsCartMutation === 'active') return;
    const button = this.querySelector('button');
    const status = this.querySelector('[role="status"]');
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
    const root = (this.dataset.root || '/').replace(/\/?$/, '/');
    this.busy = true;
    document.documentElement.dataset.rsCartMutation = 'active';
    button.disabled = true;
    this.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const response = await fetch(`${root}cart/clear.js`, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ sections, sections_url: window.location.pathname }),
      });
      const cart = await response.json();
      if (!response.ok || cart.status) throw new Error('clear-failed');
      document.dispatchEvent(new CartUpdateEvent(cart, this.id || 'rs-cart-clear', {
        source: 'rs-cart-clear', itemCount: cart.item_count, sections: cart.sections || {},
      }));
    } catch {
      status.textContent = this.dataset.error || 'İşlem doğrulanamadı. Sepetinizi kontrol edip tekrar deneyin.';
      // A lost response must not leave a stale badge or retry the mutation automatically.
      try {
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
        if (response.ok) {
          const cart = await response.json();
          document.dispatchEvent(new CartUpdateEvent(cart, 'rs-cart-clear-reconcile', { source: 'rs-cart-clear', itemCount: cart.item_count }));
        }
      } catch { /* Keep the visible failure and allow an explicit retry. */ }
    } finally {
      this.busy = false;
      delete document.documentElement.dataset.rsCartMutation;
      button.disabled = false;
      this.removeAttribute('aria-busy');
    }
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('rs-cart-clear')) customElements.define('rs-cart-clear', RsCartClear);

